export default __webpack_public_path__ + "static/media/passport.dd74e219.svg";